import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

export const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'font-size': [
        'text-body',
        'text-body-bold',
        'text-body-s',
        'text-body-s-bold',
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
